<template>
  <div class="password-dialog-box">
    <el-form
      :model="passwordForm"
      @submit="onSubmit">
      <el-dialog
        :title="isBackup() ?
          $t('wr-dashboard.password-dialog-box.title.backup') :
        $t('wr-dashboard.password-dialog-box.title.archive')"
        @close="onClose"
        :show-close="false"
        visible
      >
        <div class="el-text el-text--body-24 mx-24 my-16">
          <span v-if="isBackup()">
            {{ $t('wr-dashboard.password-dialog-box.message.backup', { displayName: this.archiveDisplayName }) }}
          </span>
          <span v-else>
            {{ $t('wr-dashboard.password-dialog-box.message.archive', { displayName: this.archiveDisplayName }) }}
          </span>
        </div>

        <el-form-item
          class="mx-24"
          prop="password">
          <el-password
            :is-error="isInvalidPassword"
            autofocus
            v-model="passwordForm.password"
            :label="$t('wr-dashboard.password-dialog-box.hint.password')"
            with-icon
          />
        </el-form-item>

        <template v-if="isInvalidPassword">
          <el-form-error
            class="mx-24 mb-16"
            style="margin-top: -23px;">
            {{ $t('wr-dashboard.password-dialog-box.message.invalid-password') }}
          </el-form-error>
        </template>

        <template slot="footer">
          <el-button
            @click="onClose"
            native-type="button"
            type="secondary">
            {{ $t('wr-dashboard.form.button.cancel') }}
          </el-button>
          <el-button
            native-type="submit"
            :loading="isInProgress"
            :disabled="isInProgress"
          >
            {{ $t('wr-dashboard.form.button.open') }}
          </el-button>
        </template>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  SETUP_ARCHIVE_PASSWORD,
  RESET_ARCHIVE_PASSWORD_STATUS
} from '../store/action-types';

import {
  PENDING_STATUS,
  SUCCESS_STATUS,
  ERROR_STATUS
} from '../store/action-status';

const { mapGetters, mapActions } = createNamespacedHelpers('wr-dashboard');

export default {
  name: 'PasswordDialogBox',
  props: {
    archiveId: {
      type: String,
      default: '',
      required: true
    },
    archiveDisplayName: {
      type: String,
      default: '',
      required: true
    },
    payload: {
      type: Object,
      default: () => ({}),
      required: false
    },
    boxGroup: {
      type: String,
      default: 'ARCHIVES',
      required: false
    }
  },
  data() {
    return {
      passwordForm: {
        password: ''
      }
    };
  },
  computed: {
    ...mapGetters([
      'getSetupArchivePasswordStatus'
    ]),
    isSuccess() {
      return this.getSetupArchivePasswordStatus === SUCCESS_STATUS;
    },
    isInvalidPassword() {
      return this.getSetupArchivePasswordStatus === ERROR_STATUS;
    },
    isInProgress() {
      return this.getSetupArchivePasswordStatus === PENDING_STATUS;
    }
  },
  watch: {
    isSuccess() {
      this.resetArchivePasswordStatus();
      this.$emit('handleSubmit', this.payload);
    }
  },
  methods: {
    ...mapActions({
      setupArchivePassword: SETUP_ARCHIVE_PASSWORD,
      resetArchivePasswordStatus: RESET_ARCHIVE_PASSWORD_STATUS
    }),
    isBackup() {
      return this.boxGroup === 'BACKUPS';
    },
    onSubmit(e) {
      this.setupArchivePassword({
        archiveId: this.archiveId,
        password: this.passwordForm.password
      });
    },
    onClose() {
      this.resetArchivePasswordStatus();
      this.$emit('handleClose');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
